<template>
    <div class="row">
        <div class="col-12 col-sm-6" v-for="column in columns">
            <div class="row">
                <div class="col-12" v-if="column.img">
                    <b-img :src="column.img" class="w-100"/>
                </div>
                <div class="col-12 block-text">
                    <h5>{{column.title}}</h5>
                </div>
                <div class="col-12 block-text">
                    <div v-html="column.text"/>
                </div>
                <b-button variant="outline-secondary" class="pull-right" :href="column.buttonHref" v-if="column.buttonHref">
                    {{column.buttonText}}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TwoColumns",
        props:{
            header: Object,
            columns: Array
        }
    }
</script>